import { feedbackAlertIcons } from "@/lib/feedback"
import type { PropsWithChildren } from 'react'
import { useState } from 'react'
import { ConfigProvider, App, theme } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/auth/AuthContext'

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
        },
      }),
  )

  return (
    <ConfigProvider
      alert={feedbackAlertIcons}
      locale={zhCN}
      modal={{ closable: { 'aria-label': '关闭' } }}
      drawer={{ closable: { 'aria-label': '关闭' } }}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#0759d9',
          colorPrimaryHover: '#064fbe',
          colorLinkHover: '#064fbe',
          colorInfo: '#0759d9',
          colorError: '#b42318',
          colorText: '#0f172a',
          colorTextSecondary: '#475569',
          colorTextDescription: '#475569',
          colorTextTertiary: '#475569',
          colorBgLayout: '#f5f7fa',
          colorBgContainer: '#ffffff',
          colorFillAlter: '#f7f9fc',
          colorBorder: '#d8e0ea',
          borderRadius: 6,
          borderRadiusLG: 8,
          controlHeight: 44,
          fontSize: 14,
          fontSizeSM: 13,
          wireframe: false,
        },
        components: {
          Button: { controlHeight: 44, fontWeight: 500 },
          Input: { controlHeight: 44 },
          Select: { controlHeight: 44 },
          Table: { cellFontSize: 14, cellPaddingBlock: 13, headerBg: '#f7f9fc', headerColor: '#334155', rowHoverBg: '#f7faff' },
          Menu: { itemHeight: 46, itemBorderRadius: 6, itemMarginInline: 10, groupTitleFontSize: 14 },
          Card: { headerFontSize: 16 },
          Tabs: { titleFontSize: 14 },
        },
      }}
    >
      <App message={{ duration: 5, maxCount: 1 }}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>{children}</AuthProvider>
        </QueryClientProvider>
      </App>
    </ConfigProvider>
  )
}
